import { useState } from 'react';
import { useOutletContext } from 'react-router-dom';
import { api, useReports } from '@/api';
import { ReportArticle } from '@/components/ReportArticle';
import { QueryPending } from '@/components/QueryState';
import { Empty } from '@/components/ui';
import type { ProjectContext } from './ProjectShell';

/** Reports as pages with numbers and conclusions. */
export function ProjectReports() {
  const { project } = useOutletContext<ProjectContext>();
  const q = useReports(project.id);
  const reports = q.data;
  const [openId, setOpenId] = useState<string>();
  const current = reports?.find((r) => r.id === (openId ?? reports[0]?.id));

  return (
    <div>
      <section className="min-w-0 max-w-4xl">
        <h2 className="mb-3 text-sm font-semibold">Отчёты</h2>
        {!reports ? (
          <QueryPending query={q} />
        ) : reports.length === 0 ? (
          <Empty title="Отчётов пока нет">{project.kind === 'retainer' ? 'Первый отчёт появится в конце недели.' : 'По проекту с фиксированной ценой отчитываемся этапами и встречами.'}</Empty>
        ) : (
          <>
            <div className="mb-4 flex flex-wrap gap-1.5">
              {reports.map((r) => (
                <button key={r.id} className="chip" aria-pressed={r.id === current?.id} onClick={() => setOpenId(r.id)}>
                  {r.period}
                </button>
              ))}
            </div>
            {current && <ReportArticle report={current} download={(id) => api.downloadDocument(id)} downloadPdf={() => api.downloadReportPdf(current.id)} />}
          </>
        )}
      </section>

    </div>
  );
}
